<template>
  <div style="height: 100%">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns" slot-scope="props">
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('wx-detail')"
          width="80px"
        >推送内容
        </grid-table-th>
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('wx-detail')"
          width="80px"
        >操作
        </grid-table-th>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <grid-table-td
          v-if="props.magicalMenuCodes.includes('wx-detail')"
          @click.native="handle(props.row)"
          width="80px"
        >查看
        </grid-table-td>
        <grid-table-td
          v-if="props.magicalMenuCodes.includes('wx-detail')"
          @click.native="changeRouter(props.row)"
          width="80px"
        >查看详情
        </grid-table-td>
      </template>
    </grid>
    <whaty-dialog
      title="推送内容"
      :visible.sync="dialogVisible"
      width="400px"
      top="32vh">
      <div class="popup-wrap" slot="body">
        <div class="popup-body">
          <div class="el-dialog__body whaty-dialog-content" style="line-height: 17px">
            <div v-html="content"></div>
          </div>
          <div class="popup-foot group" style="padding-right: 0;">
            <a href="javascript:" class="btn btn-solid-primary" @click="dialogVisible = false">确定</a>
          </div>
        </div>
      </div>
    </whaty-dialog>
  </div>
</template>
<script>
import Grid from '../../../../components/grid/grid'
import GridTableTh from '../../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../../components/grid-menu/grid-top-menu'
import util from '../../../../libs/util'
import WhatyDialog from '../../../../components/dialog/dialog'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid,
    WhatyDialog
  },
  name: 'wx-template-task-record',
  data() {
    return {
      gridConfigUrl: '',
      dialogVisible: false,
      content: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data) {
      if (!data.detail) {
        this.$notify.error({title: '推送内容', message: '该条记录无推送内容'})
      } else {
        this.showWxDetail(data.templateName, data.detail.replace(/\n/g, '<br>'))
      }
    },
    changeRouter(data) {
      if (data.errorMsg) {
        this.$msgBox.showMsgBox({
          title: '发送失败',
          content: `失败原因：<span style="color: red;">${data.errorMsg}</span>`,
          isShowCancelBtn: false
        }).catch(() => {
        })
      } else if (data.sendState.includes('已撤销')) {
        this.$notify.error({title: '查看详情', message: '无详情内容'})
      } else {
        util.changeRouter(this, {
          name: 'wx-template-send-record',
          query: {
            wxTemplateTaskRecordId: data.id
          }
        })
      }
    },
    showWxDetail(title, count) {
      this.dialogVisible = true
      this.content = '模板标题：' + title + '<br><br>' + count
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/notification/wx-template-task-record.vue